import lang from "../../../Translation/Ladning.json";

const OverPayment = ({ data }) => {
  const text = lang.OverPayment;

  // Initialize zone totals with same keys as translation
  const zoneTotals = {
    zone_1: { totalOverpayment: 0, units: 0 },
    zone_2: { totalOverpayment: 0, units: 0 },
    zone_3: { totalOverpayment: 0, units: 0 },
    zone_4: { totalOverpayment: 0, units: 0 },
  };

  // Aggregate overpayment per zone
  data.forEach((item) => {
    const overpayment = item.paymentAmount - (item.charge + item.arrears);
    const zoneKey = `zone_${item.zone.replace("zone", "")}`; // converts "zone2" → "zone_2"
    if (zoneTotals[zoneKey]) {
      zoneTotals[zoneKey].totalOverpayment += overpayment;
      zoneTotals[zoneKey].units += 1;
    }
  });

  // Calculate percentage relative to max overpayment
  const maxOverpayment = Math.max(
    ...Object.values(zoneTotals).map((z) => z.totalOverpayment)
  );

  const zonePercentages = {};
  Object.keys(zoneTotals).forEach((zone) => {
    zonePercentages[zone] =
      maxOverpayment > 0
        ? Math.round((zoneTotals[zone].totalOverpayment / maxOverpayment) * 100)
        : 0;
  });

  const totalUnits = data.length;

  return (
    <div className="p-5 rounded-md border shadow-md bg-white">
      {/* Header */}
      <div>
        <h2 className="text-xl mb-1 font-semibold uppercase">{text.title}</h2>
        <p className="text-lg mb-3 text-indigo-600 font-medium">
          RM{" "}
          {Number(
            data.reduce(
              (acc, item) => acc + (item.paymentAmount - (item.charge + item.arrears)),
              0
            )
          ).toLocaleString()}
        </p>

        <p className="text-lg">
          {text.number_of_units}:{" "}
          <span className="text-xl font-semibold text-gray-800">
            {totalUnits.toLocaleString()} Units
          </span>
        </p>
      </div>

      {/* Progress bars section */}
      <div className="mt-6 space-y-5">
        {Object.keys(zoneTotals).map((zoneKey, idx) => (
          <div key={idx}>
            <div className="flex justify-between items-center mb-1">
              <p className="text-lg font-medium text-gray-700">
                {text[zoneKey]}: {/* Now it matches your JSON */}
              </p>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-6 overflow-hidden relative">
              <div
                className="bg-blue-700 h-6 rounded-full transition-all duration-700 ease-in-out flex items-center justify-center text-white text-sm font-semibold"
                style={{ width: `${zonePercentages[zoneKey]}%` }}
              >
                {zonePercentages[zoneKey]}%
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OverPayment;
